























import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';

import Container from '~/components/Container.vue';

export default defineComponent({
  name: 'IssuuEmbed',
  components: { Container },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    issuu_url: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const formUrl = ref(props.issuu_url);

    return {
      formUrl,
    };
  },
});
